module.exports = __webpack_public_path__ + "static/media/end.6b07bf3f.svg";